module.exports = __webpack_public_path__ + "static/media/esquina_sur_abajo_1.b9491874.mp4";